{
  "add_role": "{role} toevoegen",
  "add": "Gebruiker toevoegen",
  "administrator": "Beheerder",
  "change_password_hint": "De gebruiker heeft een nieuw wachtwoord gekozen. Als het nodig is, kan het wachtwoord gereset worden.",
  "change_password": "Wijzig wachtwoord",
  "committee_category_hint": "Kies het type stembureau waar de nieuwe gebruiker deze rol voor krijgt. Deze keuze kan na het aanmaken van de gebruiker niet worden aangepast.",
  "committee_category_label": "Kies het type stembureau",
  "committee_category_title": "Voor welk type stembureau wordt deze gebruiker een {role}?",
  "coordinator": "Coördinator",
  "coordinator_csb": "Coördinator centraal stembureau",
  "coordinator_gsb": "Coördinator gemeentelijk stembureau",
  "delete_are_you_sure": "Je kan dit niet ongedaan maken. Weet je zeker dat je deze gebruiker wilt verwijderen?",
  "delete": "Gebruiker verwijderen",
  "details_title": "Details van het account",
  "expiration_warning_details": "Je bent al even niet meer actief. Je wordt automatisch uitgelogd over <strong>{time}</strong>.\n Niet opgeslagen wijzigingen gaan verloren.",
  "expiration_warning": "Je wordt bijna uitgelogd",
  "fullname_hint": "Deze is terug te zien in de logs",
  "fullname": "Volledige naam",
  "invalid_fullname": "In de volledige naam mogen geen tabs of enter zitten.",
  "invalid_username": "Gebruik alleen letters zonder accenten, cijfers en tekens zoals _ - + . !. Spaties zijn niet toegestaan.",
  "last_activity": "Laatste activiteit",
  "online": "Online",
  "manage": "Gebruikers beheren",
  "mandatory": "Dit is een verplichte vraag. Maak een keuze uit de opties hieronder.",
  "new_password": "Nieuw wachtwoord",
  "not_used": "Account nog niet gebruikt",
  "password": "Wachtwoord",
  "role_administrator_hint": "Abacus inrichten en klaarzetten voor gebruik. Inclusief voorbereiden van de verkiezing",
  "role_coordinator_hint": "Inhoudelijk expert die zitting van het stembureau begeleidt. Zittingen voorbereiden, voortgang bewaken en uitkomsten downloaden",
  "role_hint": "Kies de rol van de nieuwe gebruiker. De rol kan na het aanmaken van de gebruiker niet meer aangepast worden.",
  "role_label": "Kies een rol",
  "role_title": "Welke rol krijgt de nieuwe gebruiker?",
  "role_typist_hint": "Tellingen invoeren",
  "session_expired_title": "Je bent automatisch uitgelogd",
  "session_expired": "Je bent automatisch uitgelogd omdat je 30 minuten niets hebt gedaan.\n Log opnieuw in om verder te gaan.",
  "stay_logged_in": "Blijf ingelogd",
  "temporary_password_hint": "Gebruik minimaal 13 karakters. Het wachtwoord is hoofdlettergevoelig. De gebruiker moet na eerste keer inloggen zelf een nieuw wachtwoord kiezen.",
  "temporary_password": "Tijdelijk wachtwoord",
  "type_anonymous": "Anonieme gebruikersnaam (bijvoorbeeld 'Invoerder01')",
  "type_fullname": "Op naam (bijvoorbeeld 'MariekeDeJager')",
  "type_hint": "Gebruikers met een anoniem account moeten bij de eerste keer inloggen hun echte naam invoeren. Anonieme accounts zijn vooral handig als je veel invoerders verwacht, en nog niet precies weet wie wel en wie niet aanwezig zal zijn.",
  "type_label": "Type account",
  "type_title": "Wat voor account wil je aanmaken?",
  "typist": "Invoerder",
  "typist_csb": "Invoerder centraal stembureau",
  "typist_gsb": "Invoerder gemeentelijk stembureau",
  "unauthorized_title": "Je hebt geen toegang tot deze pagina",
  "unauthorized": "Log in met een account dat wel toegang heeft om verder te gaan.",
  "user_created_details": "{username} is toegevoegd met de rol {role}",
  "user_created": "Gebruiker toegevoegd",
  "user_deleted_details": "Het account van {name} is verwijderd",
  "user_deleted": "Gebruiker verwijderd",
  "user_updated_details": "De wijzigingen in het account van {name} zijn opgeslagen",
  "user_updated": "Wijzigingen opgeslagen",
  "username_hint_disabled": "Dit is de naam waarmee de gebruiker inlogt. De gebruikersnaam kan niet gewijzigd worden.",
  "username_hint": "Dit is de naam waarmee de gebruiker inlogt. Hoofdletters en kleine letters maken geen verschil. Gebruik alleen letters zonder accenten, cijfers en leestekens. Spaties zijn niet toegestaan.",
  "username_not_unique_error": "Er bestaat al een gebruiker met gebruikersnaam {username}",
  "username_unique": "De gebruikersnaam moet uniek zijn",
  "username": "Gebruikersnaam",
  "users": "Gebruikers"
}
